import React from 'react';
import styles from './TransportPermitsContainer.module.scss';
import { Route, Switch, Redirect } from 'react-router-dom';
import Header from './shared/components/Header/Header';
import { links } from './shared/constants/links';
import useCompanyInitialization from './shared/hooks/useCompanyInitialization';
import Loading from './shared/ui/Loading/Loading';
import TransportPage from './pages/TransportPage/TransportPage';
import PermitsPage from './pages/PermitsPage/PermitsPage';
import TransportModal from '../../components/TransportModal/TransportModal';
import { modalType, useModal } from './shared/modalProvider';

const getRoutePath = (pathname) =>
  `${links.rootWithCompany}/:companyId/${pathname}`;

const TransportPermitsContainer = () => {
  const { companyId: companyBaseId } = useCompanyInitialization();

  const { isOpen, props, close } = useModal(modalType.TRANSPORT_FORM);

  return (
    <section
      className={styles.container}
      id="TransportPermitsContainer"
    >
      <Header />
      <Switch>
        <Route
          exact
          path={links.root}
        >
          {!companyBaseId ? (
            <Loading
              size="large"
              tip="Загрузка..."
            />
          ) : (
            <Redirect
              to={`${links.rootWithCompany}/${companyBaseId}/${links.transports}`}
            />
          )}
        </Route>

        <Route
          exact
          path={getRoutePath(links.transports)}
        >
          <TransportPage />
        </Route>

        <Route
          exact
          path={getRoutePath(links.permits)}
        >
          <PermitsPage />
        </Route>
      </Switch>
      <TransportModal
        visible={isOpen}
        values={props}
        onCancel={close}
      />
    </section>
  );
};

export default TransportPermitsContainer;
